export const ROOT = 'root';

export const SS_CONTROL_TYPE = {
  BUTTON: 'ssButton',
  BUTTON_BULK_UPLOAD: 'ssButtonBulkUpload',
  BUTTON_CONTROL_PRINT: 'ssButtonControlledPrintRequest',
  BUTTON_OFFICE_ONLINE: 'ssButtonOfficeOnline',
  BUTTON_SHARE_POINT: 'ssButtonSharePoint',
  BUTTON_DECISION_TREE: 'ssButtonDecisionTree',
  BUTTON_BATCH: 'ssButtonBatch',
  BUTTON_INSPECTION_MEASUREMENT_DATA: 'ssInspectionMeasurementDataButton',
  BUTTON_SCORM: 'ssButtonScorm',
  GRID_COLUMN: 'ssGridColumn',
  SUB_GRID: 'ssSubGrid',
  GRID: 'ssGrid',
  SUB_FORM: 'ssSubForm',
  TEXT_VIEW: 'ssTextView',
  ADVANCED_TEXT_BOX: 'ssAdvancedTextBox',
  DROP_DOWN: 'ssDropDown',
  TEXT_BOX: 'ssTextBox',
  ZOOM: 'ssZoom',
  REPOSITORY_ZOOM: 'ssRepositoryZoom',
  REGULATORY_TERMS_ZOOM: 'ssRegulatoryTermsZoom',
  TEXT_AREA: 'ssTextArea',
  HYPER_LINK: 'ssHyperLink',
  FILE_INPUT: 'ssFileInput',
  DATE_BOX: 'ssDateBox',
  CHECK_BOX: 'ssCheckBox',
  NUMERIC_TEXT_BOX: 'ssNumericTextBox',
  STATIC_TEXT: 'ssStaticText',
  RADIO_BUTTON_LIST: 'ssRadioButtonList',
  FORM: 'ssForm',
  PANEL: 'ssPanel',
  REPEATING_PANEL: 'ssRepeatingPanel',
  TAB_SET: 'ssTabSet',
  SINGLE_TAB: 'ssSingleTab',
  FIELD_GROUP: 'ssFieldGroup',
  FILE_VIEWER: 'ssFileViewer',
  SAVED_SEARCH: 'ssSavedSearch',
  SCORM_FILE_INPUT: 'ssScormFileInput',
  MODAL: 'ssModal',
  FIELD_SET: 'ssFieldSet',
  SLIDER: 'ssSlider',
  ICON: 'ssIcon',
  CLUSTER_COLUMN_CHART: 'ssClusterColumnChart',
  AI_SUMMARY: 'ssSummary',
  AI_SIMILAR_RECORDS: 'ssSimilarRecords',
  DATA_CORRECTION: 'ssDataCorrection',
  ROLE_ACTORS_MANAGEMENT: 'ssRoleActorsManagement',
};

export const ZOOM_TYPES = [
  SS_CONTROL_TYPE.ZOOM,
  SS_CONTROL_TYPE.REPOSITORY_ZOOM,
  SS_CONTROL_TYPE.REGULATORY_TERMS_ZOOM,
];

export const ATTACHMENT_TYPES = ['Attachment', 'ChildAttachment', 'Content'];

export const BUTTON_LIST = [
  SS_CONTROL_TYPE.BUTTON,
  SS_CONTROL_TYPE.BUTTON_BULK_UPLOAD,
  SS_CONTROL_TYPE.BUTTON_CONTROL_PRINT,
  SS_CONTROL_TYPE.BUTTON_BATCH,
  SS_CONTROL_TYPE.BUTTON_OFFICE_ONLINE,
  SS_CONTROL_TYPE.BUTTON_SHARE_POINT,
  SS_CONTROL_TYPE.BUTTON_DECISION_TREE,
  SS_CONTROL_TYPE.BUTTON_INSPECTION_MEASUREMENT_DATA,
  SS_CONTROL_TYPE.BUTTON_SCORM,
];

export const BUTTON_TYPES = {
  SAVE_AND_SIGNOFF: 'Save',
  SAVE_WITHOUT_SIGNOFF: 'SaveNoSignOff',
  SAVE_PUBLIC_DRAFT: 'SavePublicDraft',
  CANCEL: 'Cancel',
  COPY: 'Copy',
  DELETE: 'Delete',
  OTHER: 'Other',
  SAVE_OFFLINE: 'SaveOffline',
  SUBMIT_BATCH: 'SubmitBatch',
};

export const BUTTON_DEFAULT_LABELS = {
  Save: 'Sign-off',
  SaveNoSignOff: 'Save',
  SavePublicDraft: 'Save Public Draft',
  Cancel: 'Cancel',
  Copy: 'Copy',
  Delete: 'Delete',
  Other: 'Other',
  SaveOffline: 'Save Offline',
  SubmitBatch: 'Submit Batch',
};

export const ICON_TYPES = {
  NONE: 'none',
  SUBMIT: 'submit',
  SAVE: 'save',
};

export const ICON_LABELS = {
  None: 'None',
  Submit: 'Submit',
  Save: 'Save',
};

export const STATIC_DATA_SOURCE_LIST = [
  'LST_ID',
  'LST_OBJECT_NAME',
  'LST_ORG_ID',
  'LST_PARENT_OBJECT',
  'LST_PARENT_VALUE',
  'LST_SORT_ORDER',
  'LST_VALUE',
  'LST_VALUE1',
  'LST_VALUE2',
  'LST_VALUE3',
  'LST_VALUE4',
  'LST_VALUE5',
];

export const FORM_MODEL_ATTRIBUTES = {
  LABEL: 'label',
  HIDDEN: 'hidden',
  REQUIRED: 'required',
  VIEW_ONLY: 'viewOnly',
  DISABLED_WITH_ZOOM: 'disabledWithZoom',
  DEFAULT_VALUE: 'defaultValue',
  SET_VALUE: 'setValue',
  CONTROL_TYPE: 'controlType',
  TRANSLATE_DATA: 'translateData',
  MEANING: 'meaning',
  OFFICE_ONLINE_OPTIONS: 'officeOnlineOptions',
  DATA_TOOLTIP: 'dataToolTip',
  UNIQUE_IDENTIFIER: 'uniqueIdentifier',
  ENTITY_NAME: 'entityName',
  FIELD_NAME: 'fieldName',
  VALIDATION: 'validation',
  UPDATE: 'update',
  ZOOM_SOURCE: 'zoomSource',
  DATA_LOOK_UP_TYPE: 'dataLookUpType',
  DEFAULT_LABEL: 'defaultLabel',
  DATA_SOURCE_KEY: 'dataSourceKey',
  TITLE: 'title',
  ROW_TITLE: 'rowTitle',
  LATEST_REVISION: 'latestRevision',
  CONTENT_TYPE: 'contentType',
  TEXT: 'text',
  CHILDREN_NODES: 'childrenNodes',
  HEADER: 'header',
  DISABLE_ADD: 'disableAdd',
  ADD_ROW_RULES: 'addRowRules',
  CLEAR_TABLE_RULES: 'clearTableRules',
  REBIND_CANVAS_RULES: 'rebindCanvasRules',
  DISABLE_DELETE: 'disableDelete',
  DISABLE_EDIT: 'disableEdit',
  ENABLE_COPY: 'enableCopy',
  URL: 'url',
  TERM_HIERARCHY: 'termHierarchy',
  FORM_KEY: 'formKey',
  MAPPING_ENTITY_NAME: 'mappingEntitName',
  MAPPING_FIELD_NAME: 'mappingFieldName',
  PREDICTION_CODE: 'predictionCode',
  FORM_LAST_MODIFIED: 'formLastModified',
  FORM_VERSION: 'formVersion',
  FORM_STATE: 'formState',
  DATA_OBJECT: 'dataObject',
  DATA_MAPPING_LIST: 'dataMappingList',
  CONTROL_ID: 'controlId',
  FILTER: 'filter',
  DATA_SOURCE_FILTER: 'dataSourceFilter',
  BUTTON_TYPE: 'buttonType',
  CAUSES_VALIDATION: 'causesValidation',
  COMMAND_NAME: 'commandName',
  COMMAND_ARGUMENT: 'commandArgument',
  NEED_SIGNATURE: 'needSignature',
  INITIAL_ROWS: 'initialRows',
  EXCLUDED_COLUMNS_MAPPING_LIST: 'excludedColumnsMappingList',
  FORM_NAME: 'formName',
  GRID_TYPE: 'gridType',
  USE_EXPANDABLE_ROWS: 'expandableRows',
  TOOLTIP_TEXT: 'tooltipText',
  TARGET_ID: 'targetId',
  EDIT_ALL_ROWS: 'editAllRows',
  STYLE: 'style',
  EMPTY_SECTION_MESSAGE: 'emptySectionMessage',
  ICON: 'icon',
  DISPLAY_ICON: 'displayIcon',
  DISPLAY_ICON_COLOR: 'displayIconColor',
  BATCH_PROCESS_VIEW: 'batchProcessView',
  BATCH_PROCESS_VIEW_PRIMARY_KEY: 'batchProcessViewPrimaryKey',
  BATCH_PROCESS_UPDATED_STATUS_CODE: 'batchProcessUpdatedStatusCode',
  BATCH_PROCESS_UPDATED_USER_CODE: 'batchProcessUpdatedUserCode',
  BATCH_PROCESS_UPDATED_ENTITY_NAME: 'batchProcessUpdatedEntityName',
  BATCH_PROCESS_UPDATED_PRIMARY_KEY: 'batchProcessUpdatedPrimaryKey',
  BATCH_PROCESS_UPDATED_PRIMARY_KEY_VALUE: 'batchProcessUpdatedPrimaryKeyValue',
  BATCH_PROCESS_UPDATED_MODIFIED_DATE: 'batchProcessUpdatedModifedDate',
  BATCH_PROCESS_WORKFLOW_INSTANCE_ID: 'batchProcessWorkflowInstanceId',
  BATCH_PROCESS_WORKFLOW_KEY: 'batchProcessWorkflowKey',
  BATCH_PROCESS_WORKFLOW_STEP_INSTANCE_ID: 'batchProcessWorkflowStepInstanceId',
  BATCH_PROCESS_WORKFLOW_STEP_NAME: 'batchProcessWorkflowStepName',
  BATCH_PROCESS_CHILD_RECORD_INSTANCE_ID: 'batchProcessChildRecordInstanceId',
  BATCH_PROCESS_CONTAINER_WORKFLOW_KEY: 'batchProcessContainerWorkflowKey',
  BATCH_PROCESS_ENTITY_RECORD_INSTANCE_ID: 'batchProcessEntityRecordInstanceId',
  BATCH_PROCESS_PARENT_ENTITY_NAME: 'batchProcessParentEntityName',
  BATCH_PROCESS_PARENT_WORKFLOW_INSTANCE_ID: 'batchProcessParentWorkflowInstanceId',
  SEARCH_NAME: 'searchName',
  IS_DOCUMENT_CONTENT: 'isDocumentContent',
  IS_PORTAL_CONTENT: 'isPortalContent',
  OPERATION_DELAY_MESSAGE: 'operationDelayMessage',
  STEP_ID: 'stepId',
  ITM_ID: 'itmId',
  CONTAINER_WORKFLOW_KEY: 'containerWorkflowKey',
  IS_APPROVED_FOR_ASR: 'isApprovedforASR',
  FNP_CODE: 'fnpCode',
  REGULATORY_BODY: 'regulatoryBody',
  REGULATORY_CENTER: 'regulatoryCenter',
  CURRENT_WORKFLOW_ID: 'currentWorkFlowId',
  WORKFLOW_KEY: 'workflowKey',
  DECISION_TREE_NAME: 'decisionTreeName',
  HELP_LINK_TEXT: 'formHelpLinkText',
  HELP_LINK_URL: 'formHelpLinkUrl',
  ALLOW_MULTI_SELECT: 'multiSelect',
  MAX_VALUE: 'maxValue',
  MIN_VALUE: 'minValue',
  SHOW_INPUT: 'showInput',
  COLOR: 'color',
  FONT_SIZE: 'fontSize',
  SOURCE_FIELDS: 'sourceFields',
  SOURCE_RECORD_ID: 'sourceRecordId',
  SHOW_OPERATION_COMPLETED_MESSAGE: 'showOperationCompleteMessage',
  SOURCE_ENTITY_NAME: 'sourceEntityName',
  SHOW_POST_SUMMARY_GENERATION_MESSAGE: 'showPostSummaryGenerationMessage',
  SUMMARY_GENERATION_DATE: 'summaryGenerationDate',
  EXTRA_PROMPTS: 'extraPrompts',
  POST_SUMMARY_GENERATION_MESSAGE: 'postSummaryGenerationMessage',
  OPERATION_COMPLETED_MESSAGE: 'operationCompleteMessage',
};

export const FORM_KEYS = {
  STEP: 'STEP',
  DETAIL: 'DETAIL',
  EDITOR: 'EDITOR',
  MODAL: 'MODAL',
  LINK_PREVIEW: 'LINK_PREVIEW',
};

export const PREDEFINED_DATA_SOURCES = [
  'UserActionList',
  'WorkflowPhaseAllList',
  'WorkflowPhaseCompletedList',
  'WorkflowPhaseCompletedAndClosedList',
];

export const READ_ONLY_TYPES = [
  SS_CONTROL_TYPE.CHECK_BOX,
  SS_CONTROL_TYPE.FILE_INPUT,
  SS_CONTROL_TYPE.SCORM_FILE_INPUT,
];

export const VIEW_ONLY_DATA_SOURCE_CONTROLS = [
  SS_CONTROL_TYPE.RADIO_BUTTON_LIST,
  SS_CONTROL_TYPE.DROP_DOWN,
];

export const SOURCE_TYPES = {
  COLUMN: 'column',
  TEXT: 'text',
  DATE: 'date',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  DATASOURCE: 'datasource',
  FORMULA: 'formula',
};

const PLAIN_CONTROLS = [
  SS_CONTROL_TYPE.DROP_DOWN,
  SS_CONTROL_TYPE.TEXT_BOX,
  SS_CONTROL_TYPE.ZOOM,
  SS_CONTROL_TYPE.REPOSITORY_ZOOM,
  SS_CONTROL_TYPE.TEXT_VIEW,
  SS_CONTROL_TYPE.TEXT_AREA,
  SS_CONTROL_TYPE.HYPER_LINK,
  SS_CONTROL_TYPE.BUTTON,
  SS_CONTROL_TYPE.DATE_BOX,
  SS_CONTROL_TYPE.CHECK_BOX,
  SS_CONTROL_TYPE.NUMERIC_TEXT_BOX,
  SS_CONTROL_TYPE.STATIC_TEXT,
  SS_CONTROL_TYPE.RADIO_BUTTON_LIST,
  SS_CONTROL_TYPE.BUTTON_BULK_UPLOAD,
  SS_CONTROL_TYPE.BUTTON_BATCH,
  SS_CONTROL_TYPE.BUTTON_SHARE_POINT,
  SS_CONTROL_TYPE.FILE_INPUT,
  SS_CONTROL_TYPE.BUTTON_DECISION_TREE,
  SS_CONTROL_TYPE.SLIDER,
];

export const CONTAINER_CONTROLS = [
  SS_CONTROL_TYPE.FORM,
  SS_CONTROL_TYPE.PANEL,
  SS_CONTROL_TYPE.ADVANCED_TEXT_BOX,
  SS_CONTROL_TYPE.GRID,
  SS_CONTROL_TYPE.GRID_COLUMN,
  SS_CONTROL_TYPE.SUB_GRID,
  SS_CONTROL_TYPE.REPEATING_PANEL,
  SS_CONTROL_TYPE.TAB_SET,
  SS_CONTROL_TYPE.SINGLE_TAB,
  SS_CONTROL_TYPE.FIELD_GROUP,
];

export const ALL_CONTROLS = [...PLAIN_CONTROLS, ...CONTAINER_CONTROLS];

export const CONTROLS_WITH_TOOLTIP = [...PLAIN_CONTROLS, SS_CONTROL_TYPE.SINGLE_TAB];

export const ZOOM_SOURCE_TYPE = {
  ENTITY: 'Entity',
  MERGED: 'Merged',
  FORM: 'Form',
};

export const CONTAINER_CONTROLS_WITH_MAPPING = [
  SS_CONTROL_TYPE.GRID,
  SS_CONTROL_TYPE.PANEL,
  SS_CONTROL_TYPE.REPEATING_PANEL,
];

export const DEFAULT_GRID_COLUMN_LABEL = 'Header';
export const DEFAULT_SINGLE_TAB_HEADER = 'Detail';

export const SS_FUNCTIONS_REPLACEMENT = {
  'ss.parentOrgUnitLevel(': 'ss.parentOrgUnitLevel(ssContext, ',
  'ss.parentOrgUnitType(': 'ss.parentOrgUnitType(ssContext, ',
  'ss.loggedOnDomain(': 'ss.loggedOnDomain(data',
  'ss.hasRight(': 'ss.hasRight(data, ',
  'ss.actorCode(': 'ss.actorCode(data',
  'ss.actorFullName(': 'ss.actorFullName(data',
  'ss.culture(': 'ss.culture(data',
  'ss.orgUnitCode(': 'ss.orgUnitCode(data',
  'ss.orgUnitId(': 'ss.orgUnitId(data',
  'ss.loggedOnOrgCode(': 'ss.loggedOnOrgCode(data',
  'ss.orgUnit1Id(': 'ss.orgUnit1Id(data',
  'ss.orgUnit1Code(': 'ss.orgUnit1Code(data',
  'ss.orgUnit1Name(': 'ss.orgUnit1Name(data',
  'ss.orgUnit2Id(': 'ss.orgUnit2Id(data',
  'ss.orgUnit2Code(': 'ss.orgUnit2Code(data',
  'ss.orgUnit2Name(': 'ss.orgUnit2Name(data',
  'ss.orgUnit3Id(': 'ss.orgUnit3Id(data',
  'ss.orgUnit3Code(': 'ss.orgUnit3Code(data',
  'ss.orgUnit3Name(': 'ss.orgUnit3Name(data',
  'ss.userCode(': 'ss.userCode(data',
  'ss.roleCode(': 'ss.roleCode(data',
  'ss.roleName(': 'ss.roleName(data',
  'ss.actorTitle(': 'ss.actorTitle(data',
  'ss.siteCode(': 'ss.siteCode(data',
  'ss.siteId(': 'ss.siteId(data',
  'ss.siteName(': 'ss.siteName(data',
  'ss.stepName(': 'ss.stepName(data',
  'ss.translatedStepName(': 'ss.translatedStepName(data',
  'ss.stepId(': 'ss.stepId(data',
  'ss.workflowId(': 'ss.workflowId(data',
  'ss.workflowKey(': 'ss.workflowKey(data',
  'ss.containerWorkflowKey(': 'ss.containerWorkflowKey(data',
  'ss.hasRole(': 'ss.hasRole(data, ssContext, ',
  'ss.isModuleInstalled(': 'ss.isModuleInstalled(ssContext, ',
  'ss.buildRowTitle(': 'ss.buildRowTitle(ssContext, data, ',
  'ss.buildGridTitle(': 'ss.buildGridTitle(ssContext, ',
  'ss.getEntityDataStore(': 'ss.getEntityDataStore(data ',
  'ss.getFormTranslation(': 'ss.getFormTranslation(translations, ',
  'ss.rowCount(': 'ss.rowCount(ssContext, ',
  'ss.rowCountWithFilter(': 'ss.rowCountWithFilter(ssContext, ',
  'ss.currentRecordId(': 'ss.currentRecordId(ssContext, ',
  'ss.rowIndex(': 'ss.rowIndex(ssContext, ',
  'ss.getCurrentRowValue(': 'ss.getCurrentRowValue(ssContext, ',
  'ss.sum(': 'ss.sum(ssContext, ',
  'ss.sumWithFilter(': 'ss.sumWithFilter(ssContext, ',
  'ss.columnValueWithFilter(': 'ss.columnValueWithFilter(ssContext, ',
  'ss.columnValueNotUnique(': 'ss.columnValueNotUnique(ssContext, ',
  'ss.min(': 'ss.min(ssContext, ',
  'ss.minimumValue(': 'ss.minimumValue(ssContext, ',
  'ss.minWithFilter(': 'ss.minWithFilter(ssContext, ',
  'ss.max(': 'ss.max(ssContext, ',
  'ss.maxWithFilter(': 'ss.maxWithFilter(ssContext, ',
  'ss.convertArrayToDoublePipeDelimitedString(':
    'ss.convertArrayToDoublePipeDelimitedString(ssContext, ',
  'ss.getNumberingScheme(': 'ss.getNumberingScheme(ssContext, ',
  'ss.evaluateDynamicFormula(': 'ss.evaluateDynamicFormula(ssContext, data, ',
  'ss.getApplicationSetting(': 'ss.getApplicationSetting(ssContext, ',
  'ss.isModuleLicensed(': 'ss.isModuleLicensed(ssContext, ',
  'ss.dateAddBusinessDays(': 'ss.dateAddBusinessDays(ssContext, ',
};

export const ENTITY_DATA_PREFIX = 'entityDataStore.entityData.';

export const FORM_TYPES = [SS_CONTROL_TYPE.FORM, SS_CONTROL_TYPE.SUB_FORM];

export const BOUND_CONTAINERS = [
  SS_CONTROL_TYPE.GRID,
  SS_CONTROL_TYPE.REPEATING_PANEL,
  SS_CONTROL_TYPE.PANEL,
];

export const REPEATING_CONTAINERS = [SS_CONTROL_TYPE.SUB_GRID, SS_CONTROL_TYPE.REPEATING_PANEL];

export const DATALOOKUP_TYPE_EXTERNAL_API = 'EXTERNAL_API';

export const DEFAULT_ROWS_PER_PAGE = 5;

export const SYSTEM_TABLE_KEYS_TO_EXCLUDE = ['V_ESG_', 'V_ASG_', 'V_ERM_', 'V_ECR_'];
